import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import {HolidaysCalendarDTO} from './dto/holidays-calendar.dto';
import {HolidaysCalenderService} from './holidays-calender.service';
import { HolidaysResponseModel, AllHolidaysCalendarResponseModel, HolidayDateReq } from '@gtpl/shared-models/hrms';
import { HolidaysCalendarRequest } from './dto/holidays-calendar.request';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { HolidaysCalendar } from './holidays-calendar.entity';


@Controller('holidays-calender')
export class HolidaysCalenderController {
    constructor(
        private holidaysCalendarService: HolidaysCalenderService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createHoliday')
    async createHoliday(@Body() formData: any): Promise<HolidaysResponseModel> {
    try {
        return await this.holidaysCalendarService.createHoliday(formData);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(HolidaysResponseModel, error);
      }
    }
    @Post('/updateHoliday')
  async updateHoliday(@Body() formData: any): Promise<HolidaysResponseModel> {
    try {
      return await this.holidaysCalendarService.createHoliday(formData);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(HolidaysResponseModel, error);
    }
  }
  @Post('/getAllHolidays')
  // @UseGuards(AuthGuard('jwt'))
  async getAllHolidays(): Promise<AllHolidaysCalendarResponseModel> {
    try {
      return await this.holidaysCalendarService.getAllHolidays();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllHolidaysCalendarResponseModel, error);
    }
  }
  @Post('/activateOrDeactivateHoliday')
  async activateOrDeactivateHoliday(@Body() holidayCalendarReq: HolidaysCalendarRequest): Promise<HolidaysResponseModel> {
      try {
          return await this.holidaysCalendarService.activateOrDeactivateHoliday(holidayCalendarReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(HolidaysResponseModel, err);
      }
  }
  @Post('/getAllActiveHolidays')
  async getAllActiveHolidays(@Req() request: Request): Promise<CommonResponse> {
      try {
          return await this.holidaysCalendarService.getAllActiveHolidays();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error)
      }
  }
  @Post('/getHolidayById')
  async getHolidayById(@Body() holidayCalendarReq: HolidaysCalendarRequest): Promise<HolidaysResponseModel> {
      try {
          return await this.holidaysCalendarService.getActiveHolidaysById(holidayCalendarReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(HolidaysResponseModel, err);
      }
  }

  @Post('/getHolidaysForYear')
  async getHolidaysForYear(): Promise<CommonResponse> {
    try {
      return await this.holidaysCalendarService.getHolidaysForYear();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getAllActiveHolidaysByNextDay')
  async getAllActiveHolidaysByNextDay(@Body() req: HolidayDateReq): Promise<CommonResponse> {
      try {
          return await this.holidaysCalendarService.getAllActiveHolidaysByNextDay(req);
      } catch (error) {
          error
      }
  }
}
